import { getAccessToken } from './access-token';
window.gdiHost = {
    getAccessToken,
};
